/**
 * FILE: clock-skew.interceptor.ts
 * CHỨC NĂNG: Đọc header Date của response API để ClockSkewService phát hiện giờ máy người dùng bị lệch.
 * TÁC DỤNG: Chỉ lấy request POST tới API (không bị cache trình duyệt trả lại header Date cũ). Môi trường
 * gọi API khác domain không đọc được header Date thì bỏ qua — production cùng domain vpage.nhanh.vn.
 */
import {Injectable, Injector} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable, tap} from 'rxjs';
import {environment} from '@environments/environment';
import {ClockSkewService} from '@shared/services/global/clock-skew.service';

@Injectable()
export class ClockSkewInterceptor implements HttpInterceptor {
  constructor(private readonly injector: Injector) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.method !== 'POST' || !request.url.startsWith(environment.baseUrlApi)) {
      return next.handle(request);
    }

    const requestStartedAt = Date.now();
    return next.handle(request).pipe(
      tap(event => {
        if (!(event instanceof HttpResponse)) return;
        // Lấy service lúc có response để tránh vòng phụ thuộc HttpClient ↔ interceptor khi khởi tạo.
        this.injector.get(ClockSkewService).reportServerDate(event.headers.get('Date'), requestStartedAt, Date.now());
      }),
    );
  }
}
